import { findSwipersInBlocks } from '../parts/ui';

jQuery(document).ready(function () {
    const block = $('.link-cards-block');
    if (!block.get(0)) return;
    findSwipersInBlocks('.link-cards-block', {
        spaceBetween: 20,
        breakpoints: {
            1: {
                slidesPerView: 1
            },
            530: {
                slidesPerView: 1.5
            },
            700: {
                slidesPerView: 2
            },
            993: {
                slidesPerView: 2.35
            },
            1100: {
                slidesPerView: 3
            }
        }
    });
});
